import './AppLoader.scss';
import { useTranslation } from 'react-i18next';
import spinner from '../../../assets/images/spinner.svg';

const AppLoader = ({ showText = true }) => {
  const { t } = useTranslation();

  return (
    <div className="c-app-loader">
      <div className="c-loader">
        <img
          alt="loading"
          className="loader__spinner-img"
          src={spinner}
        />
        {showText && <h1>{t('loader.text')} ...</h1>}
      </div>
    </div>
  );
};

export default AppLoader;
